/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Manual_Qc_Priority_LabelInputs */

const en_manual_qc_priority_label = /** @type {(inputs: Manual_Qc_Priority_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priority`)
};

const fr_manual_qc_priority_label = /** @type {(inputs: Manual_Qc_Priority_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorite`)
};

const de_manual_qc_priority_label = /** @type {(inputs: Manual_Qc_Priority_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorität`)
};

const it_manual_qc_priority_label = /** @type {(inputs: Manual_Qc_Priority_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Priorità`)
};

const ru_manual_qc_priority_label = /** @type {(inputs: Manual_Qc_Priority_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Приоритет`)
};

const es_manual_qc_priority_label = /** @type {(inputs: Manual_Qc_Priority_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioridad`)
};

const zh_cn2_manual_qc_priority_label = /** @type {(inputs: Manual_Qc_Priority_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`优先事项`)
};

const ja_manual_qc_priority_label = /** @type {(inputs: Manual_Qc_Priority_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`優先度`)
};

const hi_manual_qc_priority_label = /** @type {(inputs: Manual_Qc_Priority_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्राथमिकता`)
};

const pt_pt2_manual_qc_priority_label = /** @type {(inputs: Manual_Qc_Priority_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prioridade`)
};

/**
* | output |
* | --- |
* | "Priority" |
*
* @param {Manual_Qc_Priority_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const manual_qc_priority_label = /** @type {((inputs?: Manual_Qc_Priority_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Manual_Qc_Priority_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_manual_qc_priority_label(inputs)
	if (locale === "de") return de_manual_qc_priority_label(inputs)
	if (locale === "it") return it_manual_qc_priority_label(inputs)
	if (locale === "ru") return ru_manual_qc_priority_label(inputs)
	if (locale === "es") return es_manual_qc_priority_label(inputs)
	if (locale === "zh-CN") return zh_cn2_manual_qc_priority_label(inputs)
	if (locale === "ja") return ja_manual_qc_priority_label(inputs)
	if (locale === "hi") return hi_manual_qc_priority_label(inputs)
	if (locale === "pt-PT") return pt_pt2_manual_qc_priority_label(inputs)
	return en_manual_qc_priority_label(inputs)
});